import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.cleanBullets()
  }

  cleanBullets() {
    // Finde alle li-Elemente in Trix-Content und Prose
    const listItems = this.element.querySelectorAll('li')
    
    listItems.forEach(li => {
      // Hole den Text-Inhalt des li
      const text = li.textContent.trim()
      
      // Prüfe ob Text mit einem Bullet-Symbol beginnt (», •, ▸, -, *, ›, ‣, ◦, ⁃)
      const bulletSymbols = ['»', '•', '▸', '›', '‣', '◦', '⁃', '➤', '▪', '▫']
      const startsWithBullet = bulletSymbols.some(symbol => text.startsWith(symbol))
      
      if (startsWithBullet) {
        // Entferne Browser-Bullet
        li.style.listStyleType = 'none'
      } else {
        // Stelle sicher, dass Browser-Bullet angezeigt wird
        li.style.listStyleType = 'disc'
      }
    })
  }
}
